<template>
    <div class="notifications-bell-wrapper">
        <span v-if="unreadCount"
              class="number"
              :style="{ minWidth: `${badgeWidth}px` }">{{ displayCount }}</span>
        <i class="fa-solid fa-bell" />
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { useAuthStore } from '@/js/store/auth/AuthStore';
    import { loggedOutNotifications, useNotificationStore } from '@/js/store/quests/dashboard/NotificationStore';

    const authStore = useAuthStore();
    const notificationStore = useNotificationStore();
    const unreadCount = computed(() => (authStore.isUserLoggedIn ? notificationStore?.notificationCountData?.unread : loggedOutNotifications.length));

    const displayCount = computed(() => {
        if (unreadCount.value > 99) return '99+';

        return unreadCount.value.toString();
    });

    const badgeWidth = computed(() => {
        if (unreadCount.value > 99) return 24;
        if (unreadCount.value > 9) return 20;

        return 16;
    });
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/partials/z-index" as ZIndex;
@use "@/sass/partials/breakpoints" as breakpoints;
@use "@/sass/design-system/variables" as variables;

.notifications-bell-wrapper {
    position: relative;

    @media (max-width: breakpoints.$md-breakpoint-max-width) {
        margin-left: 23px;
    }

    i {
        position: relative;
        display: flex;
        align-items: center;
        color: legacyVariables.$light-grey-blue;
        cursor: pointer;
        font-size: 19px;
        transition: color 200ms ease;

        &:hover {
            color: variables.$baseWhite;
        }
    }

    .number {
        position: absolute;
        z-index: ZIndex.$header-p-z-index;
        top: -7px;
        right: -7px;
        display: flex;
        min-width: 16px;
        height: 16px;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        border-radius: 8px;
        background-color: legacyVariables.$down-color;
        color: variables.$baseBlack;
        font-size: 10px;
        font-weight: 700;
        line-height: 14px;
        pointer-events: none;

        &::before {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            width: 12px;
            height: 12px;
            border-radius: 8px;
            margin: auto;
            animation: pulse-me 1.7s linear infinite;
            background-color: legacyVariables.$down-color;
            content: "";
            transform: scale(0.4);
            transform-origin: center center;
        }

        @keyframes pulse-me {
            0% {
                opacity: 0;
                transform: scale(0.3);
            }

            50% {
                opacity: 0.5;
            }

            60% {
                opacity: 0.3;
            }

            100% {
                opacity: 0;
                transform: scale(3);
            }
        }
    }
}
</style>
